var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoLearnerFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Learner Found"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.4446 41.2092L36.4658 47.188",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.4446 47.188L36.4658 41.2092",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.1935 25.9022C28.9815 25.881 28.7271 25.881 28.4939 25.9022C23.448 25.7325 19.4409 21.5983 19.4409 16.51C19.4409 11.3156 23.6388 7.09656 28.8543 7.09656C34.0487 7.09656 38.2677 11.3156 38.2677 16.51C38.2465 21.5983 34.2395 25.7325 29.1935 25.9022Z",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.8544 49.0963C24.9958 49.0963 21.1584 48.1211 18.2326 46.1705C13.1018 42.7359 13.1018 37.1388 18.2326 33.7253C24.0629 29.8243 33.6248 29.8243 39.4551 33.7253",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLearnerFound);
export default __webpack_public_path__ + "static/media/no-learnerFound.b1f4c3210581cec8e0705a178db26434.svg";
export { ForwardRef as ReactComponent };